<template>

    <div>

        <h1 class="legal-heading">Impressum</h1>

        <p class="legal-sub">Angaben gemäß § 5 E-Commerce-Gesetz (ECG) und § 25 Mediengesetz</p>

        <div class="legal-block">

            <p>
                <strong>Unternehmensinhaber:</strong><br>
                Daniel Wiesner
            </p>

            <p>
                <strong>Unternehmensbezeichnung:</strong><br>
                WIESNERD Daniel Wiesner
            </p>

            <p>
                <strong>Anschrift:</strong><br>
                Tulpenweg 3<br>
                5121 St. Radegund<br>
                Österreich
            </p>

            <p>
                <strong>Kontakt:</strong><br>
                E-Mail: <a href="mailto:office@wiesnerd.at">office@wiesnerd.at</a>
            </p>

            <p>
                <strong>Umsatzsteuer-Identifikationsnummer:</strong><br>
                ATU77035138
            </p>

        </div>

        <div class="legal-block">

            <p>
                <strong>Unternehmensgegenstand:</strong><br>
                Dienstleistungen in der automatischen Datenverarbeitung und Informationstechnik sowie Mechatronik
            </p>

            <p>
                <strong>Berufsrecht:</strong><br>
                Gewerbeordnung 1994 (GewO), abrufbar unter
                <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener">ris.bka.gv.at</a>
            </p>

            <p>
                <strong>Zuständige Behörde:</strong><br>
                Bezirkshauptmannschaft Braunau am Inn
            </p>

            <p>
                <strong>Mitglied der:</strong><br>
                Wirtschaftskammer Österreich (WKO)
            </p>

        </div>

        <div class="legal-block">

            <p>
                <strong>Haftungshinweis:</strong><br>
                Trotz sorgfältiger inhaltlicher Kontrolle übernehme ich keine Haftung für die Inhalte externer Links.
                Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
            </p>

        </div>

    </div>

</template>

<script>

    export default {

        name: 'TheImpressumView',

    }

</script>

<style scoped>

    .legal-heading {

        font-size: 1.6rem;
        font-weight: 700;
        color: #1a2a3a;
        margin-bottom: 0.25rem;

    }

    .legal-sub {

        font-size: 0.85rem;
        color: #7a8a9a;
        margin-bottom: 2rem;

    }

    .legal-block {

        margin-bottom: 1.75rem;
        padding-bottom: 1.75rem;
        border-bottom: 1px solid #e4edf5;

    }

    .legal-block:last-child {

        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;

    }

    .legal-block p {

        color: #4a5a6a;
        line-height: 1.7;
        margin-bottom: 0.75rem;

    }

    .legal-block p:last-child {

        margin-bottom: 0;

    }

    .legal-block a {

        color: #0B5FA5;
        text-decoration: none;

    }

    .legal-block a:hover {

        text-decoration: underline;

    }


</style>
